import { Box, Button, IconButton as MuiIconButton } from "@mui/material";
import React from "react";
import { closePopup } from "../../../style/images";
import { translate } from "../../services";

export const RemoveProductsCart = (props)=>{

        return <div className="delete-cart">
            <Box sx={{display: "flex",
                    width: "100%",
                    flexDirection: "column",
                    alignItems: "flex-end",
                    gap: "12px"}}>
                        {/* <IconButton onClick={props.onClose} width="24px" height="24px" sx={{position:"absolute", top:"12px", right:"12px", background:"#F5F5F5", height:"20px", width:"20px", borderRadius:"56px", backgroundColor: 'white'}}>
                            <Box component="img" src={closePopup}></Box>
                        </IconButton> */}
                        <MuiIconButton disableFocusRipple disableRipple disableTouchRipple onClick={props.onClose} sx={{position:"absolute", top:"12px", right:"12px", background:"#F5F5F5",width:{md:"24px", xs:"18px"}, height:{md:"24px", xs:"18px"}, borderRadius:"56px" , backgroundColor: 'white'}}>
                                <Box component="img" src={closePopup} style={{width: 'inherit', height: 'inherit'}} sx={{height:"24px", width:"24px"}}></Box>
                        </MuiIconButton>
                        <Box width="100%" sx={{display: "flex",
                                                width: "100%",
                                                flexDirection: "column",
                                                alignItems: "flex-start",
                                                gap: {md:"12px", xs:"24px"}}}>
                                        
                                        <Box width="100%" sx={{display:"flex", justifyContent:{md:"start", xs:"center"}}}>
                                            <span className="H5-font">{translate(!props.singleItemRemove?"Remove products":"Remove product")}</span>
                                        </Box>
                                        <Box width="100%" sx={{display:"flex", justifyContent:"start", alignItems:"center", wordBreak:"break-all"}}>
                                            <span className="regular-font">{translate(!props.singleItemRemove?"Do you really want to remove all items from the cart?":props.text)}</span>
                                        </Box>
                        </Box>
                        <div className="footer">
                        <div className="primary-button" onClick={(e)=>{e.stopPropagation();props.onDelete()}}>
                                    <span>{translate("Remove")}</span>
                                    </div>
                                    <div className="tertiary-button" onClick={(e)=>{e.stopPropagation();props.onClose()}}>
                                        <span className="cancel-btn">{translate("Cancel")}</span>
                                    </div>
                                   
                        </div>
                    </Box>
        </div>
}